/**
 * NOTE! This is a hacky experiment to test if the game crashes with many repeated loadings and unloadings of the poker
 * scene, which may be more likely to cause issues on mobile or underpowered devices.
 */
import { delay } from './utils';
const TIMEOUT_MS = 10000;
const INTERVAL_MS = 500;
const NUM_LOOPS = 10;
const ALL_STRESS_TEST_STEPS = [
    'open-create-game-modal',
    'create-game',
    'wait-for-poker-room',
    'open-menu',
    'click-exit-room'
];
const STRESS_TEST_FNS = {
    'open-create-game-modal': async () => {
        const button = (await waitForElement("[data-testid='open-create-game-modal-button']"));
        button.click();
    },
    'create-game': async () => {
        const button = (await waitForElement("[data-testid='create-game-button']"));
        button.click();
    },
    'wait-for-poker-room': async () => {
        await waitForElement("[data-testid='poker-stage-container']");
        await delay(1000);
    },
    'open-menu': async () => {
        const button = (await waitForElement("[title='Open Menu']"));
        const pointerDownEvent = new PointerEvent('pointerdown', {
            bubbles: true,
            cancelable: true,
            pointerId: 1,
            pointerType: 'mouse'
        });
        button.dispatchEvent(pointerDownEvent);
        await delay(500);
    },
    'click-exit-room': async () => {
        const button = (await waitForElement("[data-testid='exit-room-button']"));
        button.click();
    }
};
export async function runStressTest() {
    console.warn('Stress test starting...');
    let loopCount = 0;
    let stepIndex = 0;
    while (loopCount < NUM_LOOPS) {
        const currentStressTestStep = ALL_STRESS_TEST_STEPS[stepIndex];
        console.warn(`Stress test step: ${currentStressTestStep}`);
        const stepStartMs = performance.now();
        await STRESS_TEST_FNS[currentStressTestStep]();
        console.warn(`Stress test step done: ${currentStressTestStep}, took ${(performance.now() - stepStartMs).toLocaleString()}ms`);
        stepIndex++;
        if (stepIndex === ALL_STRESS_TEST_STEPS.length) {
            stepIndex = 0;
            loopCount++;
            console.warn(`Stress test loop ${loopCount} done.`);
        }
    }
    console.warn(`Stress test done, loops: ${NUM_LOOPS}`);
}
async function waitForElement(selector, startMs) {
    if (startMs === undefined) {
        startMs = performance.now();
    }
    const element = document.body.querySelector(selector);
    if (element) {
        return element;
    }
    const elapsedMs = performance.now() - startMs;
    if (elapsedMs > TIMEOUT_MS) {
        throw new Error(`did not find: ${selector}`);
    }
    return new Promise((resolve) => {
        setTimeout(() => {
            waitForElement(selector, startMs).then(resolve);
        }, INTERVAL_MS);
    });
}
